import IntercomSDK, {
  showNewMessage as showNewIntercomMessage,
  shutdown as shutdownIntercom,
  update as updateIntercom,
} from '@intercom/messenger-js-sdk';
import { UserArgs } from '@intercom/messenger-js-sdk/types';

import constants from '../../constants.json';
import { getIntercomJwt } from '../intercom.service';
import { logger } from '../loggerService';

export const useProductionIntercomAppId =
  constants.GIT_BRANCH === 'master' && process.env.ENVIRONMENT === 'production';
const intercomAppId = useProductionIntercomAppId ? 'uhituceq' : 'vyptbpab';

/**
 * Intercom defaults to the maximum z-index (MOB-876). 150 sits above legacy ad-hoc z-indexes
 * (max 101) and below Portal chrome and ui-library overlays (200+). The banner frame ignores the
 * setting, so NewSidebarPortalStyles pins it to this value with CSS. See
 * src/layouts/Portal/AGENTS.md, Stacking.
 */
export const INTERCOM_Z_INDEX = 150;

const initialiseIntercom = async (disable = false): Promise<void> => {
  if (disable) {
    return;
  }
  try {
    const token = await getIntercomJwt();

    IntercomSDK({
      app_id: intercomAppId,
      intercom_user_jwt: token,
      z_index: INTERCOM_Z_INDEX,
    });
  } catch (error) {
    if (error instanceof Error && error?.message?.includes('User not supported at this time')) {
      logger.warn('Intercom user not supported yet', { error });
    } else {
      logger.error('Error initialising Intercom', { error });
    }
  }
};

export const useIntercom = () => {
  const update = (updates: UserArgs) => {
    updateIntercom(updates);
  };

  const shutdown = () => {
    shutdownIntercom();
  };

  const showNewMessage = (message: string) => {
    showNewIntercomMessage(message);
  };

  return {
    showNewMessage,
    update,
    shutdown,
  };
};

export const Intercom = {
  initialize: initialiseIntercom,
};
